import { Injectable } from '@angular/core';
import { DialogRef, DialogService, TypedDialog } from 'shared/ui';

import { ReadingModeDialogComponent } from '../dialogs/reading-mode-dialog/reading-mode-dialog.component';
import { SharedUserService } from 'shared/services';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReadingGroupDialogService {
  private _allowedSingleMode = false;

  constructor(
    private _dialogService: DialogService,
    private _userService: SharedUserService
  ) {
    this._userService.user.pipe(first()).subscribe((result) => {
      if (result && result.allow_single_mode) {
        this._allowedSingleMode = true;
      }
    });
  }

  openReadingModeSelection(
    bid: string,
    bookTitle: string,
    cover: string,
    bookAuthor: string,
    invitedGroupId?: number
  ): DialogRef<
    TypedDialog<
      {
        bid: string;
        bookTitle: string;
        cover: string;
        bookAuthor: string;
        invitedGroupId?: number;
      },
      { canceled?: boolean; groupId?: number }
    >,
    { canceled?: boolean; groupId?: number }
  > {
    return this._dialogService.open(ReadingModeDialogComponent, {
      data: {
        bid,
        bookTitle,
        cover,
        bookAuthor,
        allowedSingleMode: this._allowedSingleMode,
        invitedGroupId,
      },
    });
  }
}
